<template>
  <div>
    <status-bar :status="status"></status-bar>
    <div class="row-bg">
      <div class="row row1">
        <p class="r-location r-province" :class="workProvince=='工作地-省份'?'':'txt-color'" @click="provincePickerClick">{{workProvince}}</p>
      </div>
      <div class="row row1">
        <p class="r-location r-city" :class="workCity=='工作地-城市'?'':'txt-color'"  @click="cityPickerClick">{{workCity}}</p>
      </div>
       <div class="row">
         <p :class="JgFrom.value=='机构信息来源'?'':'txt-color'" @click="organizationClick">{{JgFrom.value}}</p>
       </div>
      <div class="row">
        <p :class="msgFrom.value=='招募信息来源'?'':'txt-color'" @click="fromPickerClick">{{msgFrom.value}}</p>
      </div>
      <div class="row">
        <input
        type="tel"
        maxlength="11"
        placeholder="紧急联系人手机"
        v-model="contactPhone"
        @blur="inputBlurEvent"
        >
      </div>
    </div>
    <p class="next-btn" :class="complete" @click="showConfirmBox">下一步</p>
    <p class="detail">找不到的某个城市表示该城市暂未开通代驾服务</p>
    <div class="confirm" :class="showConfirm?'show':'hide'">
      <div class="c-bg">
        <div class="c-title">
          <p>请确认所录入信息正确</p>
        </div>
        <div class="c-content">
          <p>工作地：{{workProvince+" "+workCity}}</p>
          <p>招募信息来源：{{msgFrom.value}}</p>
          <p>机构信息来源：{{JgFrom.value}}</p>
          <p>紧急联系人手机：{{contactPhone}}</p>
        </div>
        <div class="c-bottom">
          <p class="c-cancel" @click="cancelBtnAction">返回修改</p>
          <p class="c-sure" @click="sureBtnAction">确认提交</p>
        </div>
      </div>
    </div>
    <awesome-picker
      ref="picker1"
      :data="picker.data1"
      :textTitle="picker.textTitle1"
      :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel"
      @cancel="handlePickerCancel"
      @confirm="handlePickerConfirm1"
    ></awesome-picker>
    <awesome-picker v-for="item in options" :key="item.num"
      ref="picker2"
      :data="picker.data2"
      :textTitle="picker.textTitle2"
      :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel"
      @cancel="handlePickerCancel"
      @confirm="handlePickerConfirm2"
    >{{item.num}}</awesome-picker>
    <awesome-picker
      ref="picker3"
      :data="picker.data3"
      :textTitle="picker.textTitle3"
      :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel"
      @cancel="handlePickerCancel"
      @confirm="handlePickerConfirm3"
    ></awesome-picker>
    <awesome-picker
      ref="picker4"
      :data="picker.data4"
      :textTitle="picker.textTitle4"
      :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel"
      @cancel="handlePickerCancel"
      @confirm="handlePickerConfirm4"
    ></awesome-picker>
  </div>
</template>

<script>
import StatusBar from '../../components/StatusBar'
import {showToast, changeHistory} from '../../utils/common'
import {getCityOpen, getSignUpInfo, updateBasic,commonOrganization} from '../../utils/actions'
import {mapGetters} from 'vuex'
export default {
  name: 'SignUp',
  components: {
    StatusBar
  },
  data () {
    return {
      options: [],
      status: '',
      workCity: '工作地-城市',
      workCityId: '',
      workProvince: '工作地-省份',
      msgFrom: {value: '招募信息来源', index: ''},
      JgFrom: {value: '机构信息来源', id: ''},
      contactPhone: '',
      showConfirm: false,
      picker: {
        textTitle1: '请选择工作地省份',
        textTitle2: '请选择工作地城市',
        textTitle3: '请选择招募信息来源',
        textTitle4: '请选择城市机构',
        textConfirm: '确定',
        textCancel: '取消',
        swipeTime: 1800,
        data1: [],
        data2: [],
        data3: [],
        data4: []
      }
    }
  },
  created () {
    this.status = this.$route.params.status
    this.getOpenProvince()
    this.getMsgFrom()
    changeHistory()
  },
  methods: {
    async getJg(id){
      let json= await commonOrganization({city_id:id});
      if(!json)return;
      let list = [];
        for (let key in json.data) {
          let city = {
            value: json.data[key],
            id: key,
          }
          list.push(city)
        };
        this.picker.data4 = list
    },
     organizationClick(){
       if (this.workCity === '工作地-城市') {
        showToast('请先选择城市')
        return
      };
       if (this.picker.data4.length<1) {
        showToast('暂时无法获取注册机构名单,请咨询代驾公司服务人员')
        return
      };
       this.$refs.picker4.show()
     },
      handlePickerConfirm4 (e) {
        this.JgFrom = {
          value:e[0].value,
          id:this.picker.data4[e[0].index].id
        }
    },

    provincePickerClick () {
      this.workCity = '工作地-城市';
      this.JgFrom={value: '机构信息来源', id: ''};
      this.$refs.picker1.show()
      this.options = []
      var that = this
      setTimeout(() => {
        that.options = [{num: 1}]
      }, 100)
    },
    cityPickerClick () {
      this.JgFrom={value: '机构信息来源', id: ''};
      if (this.picker.data2.length<1||this.workProvince === '工作地-省份') {
        showToast('请先选择正确的省份')
        return
      }
      this.$refs.picker2[0].show()
    },
    fromPickerClick () {
      this.$refs.picker3.show()
    },
    handlePickerCancel (e) {
    },
    getOpenProvince () {
      var that = this
      getCityOpen({type: 1}).then(function (res) {
        if(!res)return
        that.picker.data1 = []
        for (let key in res.data.province) {
          let province = {
            value: res.data.province[key],
            id: key
          }
          that.picker.data1.push(province);
        }
      })
    },
    getOpenCity (id) {
      this.picker.data2 = []
      if (!id || id === 999) {
        return
      }
      var that = this
      getCityOpen({type: 2, parent_id: id}).then(function (res) {
        if(!res)return
        var list = []
        for (let key in res.data) {
          let city = {
            value: res.data[key],
            id: key
          }
          list.push(city)
        }
        that.picker.data2 = list
      })
    },
    getMsgFrom () {
      var parm = {
        token:this.userInfo.token,
        id: this.userInfo.id
      }
      var that = this
      getSignUpInfo(parm).then(function (res) {
        if(!res)return
        var list = res.data.src_list
        for (var key in list) {
          if (key < 0) {
            break
          }
          var obj = {
            value: list[key]
          }
          that.picker.data3.push(obj)
        }
      })
    },
    handlePickerConfirm1 (e) {
      this.workProvince = e[0].value
      var info = this.picker.data1[e[0].index]
      this.getOpenCity(info ? info.id : 999)
    },
    handlePickerConfirm2 (e) {
      this.workCity = e[0].value
      let cityId= this.picker.data2[e[0].index].id;
      this.workCityId =cityId;
      this.getJg(cityId)
    },
    handlePickerConfirm3 (e) {
      this.msgFrom.value = e[0].value
      this.msgFrom.index = e[0].index
    },
    nextBtnClick () {
      if (this.workProvince === '工作地-省份') {
        showToast('请选择工作地省份')
        return
      }
      if (this.workCity === '工作地-城市') {
        showToast('请选择工作地城市')
        return
      }
      if (this.msgFrom.value === '招募信息来源') {
        showToast('请选择招募信息来源')
        return
      }
      if (this.JgFrom.value === '机构信息来源') {
        showToast('请选择机构信息来源')
        return
      }
      if (!(/^[1][3456789]\d{9}$/).test(this.contactPhone)) {
        showToast('请输入正确的紧急联系人手机号码')
        return
      }
      var param = {
        token:this.userInfo.token,
        id: this.userInfo.id,
        mobile: this.userInfo.mobile,
        city_id: this.workCityId,
        src: this.msgFrom.index,
        organization_id: this.JgFrom.id,
        method: 'driver.signup.update_basic',
        address: this.workProvince + this.workCity,
        contact_phone: this.contactPhone
      }
      var that = this
      updateBasic(param).then(function (res) {
        if (res && res.code === 0) {
          that.$router.push({name: 'recruitAnswer', params: {status: '2'}})
        }
      })
    },
    inputBlurEvent () {
      window.scroll(0, 0)
    },
    cancelBtnAction () {
      this.showConfirm = false
    },
    sureBtnAction () {
      this.cancelBtnAction()
      this.nextBtnClick()
    },
    showConfirmBox () {
     
      if (this.workCity !== '工作地-城市' && this.workProvince !== '工作地-省份'  && this.msgFrom.value !== '招募信息来源' && this.JgFrom.value !== '机构信息来源'  && this.contactPhone.length === 11) {
        this.showConfirm = true
      } else {
        this.nextBtnClick()
      }
    }
  },
  computed: {
    complete () {
      // 
      if (this.workCity !== '工作地-城市' && this.workProvince !== '工作地-省份'&& this.msgFrom.value !== '招募信息来源'  && this.contactPhone.length === 11) {
        return ''
      }
      return 'opactiy'
    },
    ...mapGetters({
      userInfo:'getUserInfo'
    })

  }
}
</script>
<style lang="scss" scoped>
.row-bg {
  margin: 1.18rem 0.86rem 0.8rem;
  font-size: 0.28rem;
  box-sizing: border-box;
  .row {
    width: 100%;
    height: 0.98rem;
    border-bottom: 1px solid #e8e9eb;
    p {
      height: 0.98rem;
      width: 100%;
      line-height: 1.3rem;
      color: #97989b;
      background: url("../../assets/triangle_open@2x.png") right 70%
        no-repeat;
      background-size: 0.12rem 0.08rem;
    }
    input {
      border: none;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      padding-left: 0;
      padding-top: 0.3rem;
      background-color: transparent;
    }
    .txt-color {
      color: #19191a !important;
    }
  }
  .row1 {
    position: relative;
    p {
      display: inline-block;
    }
    .r-location{
      position: absolute;
      right: 0;
      width: 100%
    }
  }
}

.next-btn {
  width: 90%;
  margin-left: 5%;
  text-align: center;
  font-size: 0.3rem;
  height: 0.92rem;
  line-height: 0.92rem;
  color: #ffffff;
  border-radius: 0.04rem;
  background-image: linear-gradient(-269deg, #F25050 0%, #C93131 100%);
}
.opactiy{
  opacity: 0.3;
}

.detail {
  margin-top: 0.2rem;
  width: 100%;
  text-align: center;
  font-size: 0.24rem;
  color: #97989b;
}

.confirm{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  .c-bg{
    position: absolute;
    top: 3rem;
    transform: translateX(-50%);
    width: 6.5rem;
    height: 4.8rem;
    left: 50%;
    background: #FFFFFF;
    box-shadow: 0 0 0.1rem 0 rgba(0,0,0,0.20);
    border-radius: 2px;
    .c-title{
      text-align: center;
      font-size: 0.32rem;
      color: #19191A;
      p{
        padding-top: 0.54rem;
      }
    }
    .c-content{
      font-size: 0.28rem;
      color: #19191A;
      margin-left: 1.12rem;
      margin-top: 0.4rem;
    }
    .c-bottom{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      font-size: 0.32rem;
      height: 1rem;
      box-sizing: border-box;
      text-align: center;
      border-top: 1px solid #E8E9EB;
      display: flex;
      p{
        flex: 1;
        height: 100%;
        line-height: 1rem;
      }
      .c-cancel{
        color: #646566;
      }
      .c-sure{
        border-left: 1px  solid #E8E9EB;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/sign-up/index.vue